import { h, Component } from 'preact';
import emailValidator from 'email-validator';
import ReactPixel from 'react-facebook-pixel';
import TextBox from '../textBox/textBox';
import Button from '../button/button';
import InlineMessage from '../inlineMessage/inlineMessage';
import styles from './contactForm.css';
import config from '../../config.json';

const API = `${config.firebase.cloudFunctionUrl}/getInTouch`;

export default class ContactForm extends Component {
  state = {
    errors: [],
    sending: false,
    sent: false,
    name: '',
    phone: '',
    email: '',
    comments: ''
  }

  isFormValid = () => {
    const { name, email, phone } = this.state;
    if (!name.length || !email.length || !phone.length) {
      return false;
    }

    if (!emailValidator.validate(email)) {
      return false;
    }

    return true;
  }

  getFormErrors = () => {
    const { name, email, phone } = this.state;
    const errors = [];
    if (!name.length) {
      errors.push('Enter your name so we know who we\'ll be getting in touch with')
    }

    if (!phone.length) {
      errors.push('Enter your phone number so we know who to call');
    }

    if (!emailValidator.validate(email)) {
      errors.push('Check that the email address is correct (it doesn\'t look valid)');
    }

    ga('send', 'event', 'ContactForm', 'Errors', errors.length);
    return errors;
  }


  onTextChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onContact = () => {
    const errors = this.getFormErrors();
    if (errors.length) {
      this.setState({
        errors
      });
      return;
    }

    const { name, email, phone, comments } = this.state;
    ga('send', 'event', 'ContactForm', 'Form', 'FetchSend');
    fetch(API, {
      mode: 'cors',
      headers:{
        'Content-Type': 'text/plain',
        'Access-Control-Allow-Origin': true
      },
      method: 'POST',
      body: JSON.stringify({
        name,
        email,
        phone,
        comments
      })
    }).then((res) => {
      console.log(res.status);
    });

    this.setState({
      sending: true,
      errors: []
    });

    setTimeout(() => {
      ga('send', 'event', 'ContactForm', 'Form', 'Send');
      ReactPixel.track('Lead', {
        content_name: 'Contact'
      });
      this.setState({
        sent: true
      });
    }, 1000);
  }

  renderErrors = () => {
    const { errors } = this.state;

    if (!errors.length) {
      return null;
    }
    return (<InlineMessage type="error">
      <p className={styles.errorTitle}>Uh-oh, looks like there are some issues with your contact details. Can you please:</p>
      <ul className={styles.errorList}>
        {errors.map((e, idx) => <li key={idx}>{e}</li>)}
      </ul>
    </InlineMessage>);
  }

  render(props, { name, phone, email, comments, sent, sending }) {

    if (sent) {
      return <InlineMessage type="success">Thanks! Someone will in touch shortly</InlineMessage>;
    }

    const buttonText = sending ? 'Sending...' : 'Get in touch';

    return (<div>
      {this.renderErrors()}
      <TextBox name="name" onChange={this.onTextChange} label="Your name" value={name} className={styles.input} />
      <TextBox name="phone" onChange={this.onTextChange} label="Your phone number" value={phone} className={styles.input}/>
      <TextBox name="email" onChange={this.onTextChange} label="Your email address" value={email} className={styles.input}/>
      <TextBox multiline name="comments" onChange={this.onTextChange} label="Is there anything else you want to add?" value={comments} />
      <Button disabled={sending || sent} className={styles.button} onClick={this.onContact}>{buttonText}</Button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/contactForm/contactForm.jsx